import axios from "axios";

const url = process.env.REACT_APP_API_URL_VIEWSMKHP;

export default class ViewService {
    getHcByAju(noAju) {
        return axios.get(url + '/gethcbyaju/'+ noAju)
    }
    
    getUptByAju(kdUpt) {
        return axios.get(url + '/getuptbyaju/'+ kdUpt)
    }
    
    getNegaraByAju(kdNegara) {
        return axios.get(url + '/getnegarabyaju/'+ kdNegara)
    }
    
    getPelabuhanByAju(kdPelabuhan) {
        return axios.get(url + '/getpelabuhanbyaju/'+ kdPelabuhan)
    }

    getPpkByAju(noAju) {
        return axios.get(url + '/getppkbyaju/'+ noAju)
    }
    
    getPpkMutuByAju(noAju) {
        return axios.get(url + '/getppkmutubyaju/'+ noAju)
    }
    
    getPpkMutuAreaByAju(noAju) {
        return axios.get(url + '/getppkmutuareabyaju/'+ noAju)
    }
    
    getPpkContainerByAju(noAju) {
        return axios.get(url + '/getppkcontainerbyaju/'+ noAju)
    }
    
    getPpkDtlByAju(noAju) {
        return axios.get(url + '/getppkdtlbyaju/'+ noAju)
    }
    
    getPpkMutuProdByAju(noAju) {
        return axios.get(url + '/getppkmutuprodbyaju/'+ noAju)
    }
    
    getJumlahKemasanByAju(noAju) {
        return axios.get(url + '/getppkkemasanbyaju/'+ noAju)
    }
    
    getUraianKemasanByKd(kdKemas) {
        return axios.get(url + '/getkemasanbykd/'+ kdKemas)
    }
}
